import { CtaButton, Heading, IconList, Subtitle } from '@zappyrent/hundop';
import { rem } from 'polished';
import styled from 'styled-components';

export const StyledArticle = styled.article`
  position: relative;
  margin: ${rem('16px')} 0 ${rem('40px')} 0;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    margin: ${rem('64px')} 0;
  }
`;

export const StyledSection = styled.section`
  margin-bottom: ${rem('40px')};
  scroll-margin-top: ${rem('144px')};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    scroll-margin-top: ${rem('72px')};
  }
`;

export const StyledContainer = styled.section`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    flex-direction: row;
  }
`;

export const StyledHeaderSection = styled.section`
  width: 100%;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    padding-bottom: ${rem('120px')};
  }
`;

export const StyledSubContainer = styled.section`
  display: flex;
  flex-direction: column;

  & #pubblica-annuncio-gratis a {
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
      margin-bottom: ${rem('40px')};
    }
  }

  & #perche-affittare-casa {
    margin-bottom: 0;

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
      margin-bottom: ${rem('80px')};
    }
  }
  & #faq {
    margin-bottom: 0;
  }
`;

export const StyledH1 = styled(Heading)`
  margin-bottom: ${rem('24px')};
`;

export const StyledH2 = styled(Subtitle)`
  color: ${({ theme }) => theme.colors.cross.grayson};
  margin-bottom: ${rem('32px')};
  line-height: 1.2;
`;

export const StyledH3 = styled(Heading)`
  margin-bottom: ${rem('24px')};
  color: ${({ theme }) => theme.colors.cross.black};
`;

export const StyledButtonContainer = styled.div`
  margin: ${rem('40px')} 0;
`;

export const StyledCtaButton = styled(CtaButton)`
  background-color: ${({ theme }) => theme.colors.landlord.main};
  text-transform: uppercase;
  border: 1px solid ${({ theme }) => theme.colors.landlord.main};
  border-bottom: none;
  width: 100%;

  &:hover:not(:disabled) {
    background-color: ${({ theme }) => theme.colors.landlord.mainAlternate};
    border: 1px solid ${({ theme }) => theme.colors.landlord.mainAlternate};
    border-bottom: none;
  }
`;

export const StyledSubtitle = styled(Subtitle)`
  margin: ${rem('24px')} 0 ${rem('16px')} 0;
`;

export const StyledLargeSubtitle = styled(Subtitle)`
  margin: ${rem('40px')} 0;
`;

export const StyledLink = styled.a`
  text-decoration: none;
  color: ${({ theme }) => theme.colors.landlord.main};
`;

export const StyledIconList = styled(IconList)`
  display: flex;
  flex-direction: column;
  margin-bottom: ${rem('24px')};

  & li {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    padding: 0;

    & span {
      position: static;
      width: ${rem('32px')};

      & svg {
        margin-bottom: ${rem('8px')};
      }
    }

    & p:nth-child(2) {
      margin-bottom: ${rem('8px')};
      color: ${({ theme }) => theme.colors.cross.black};
    }

    & p:nth-child(3) {
      color: ${({ theme }) => theme.colors.cross.grayson};
    }

    & strong {
      color: ${({ theme }) => theme.colors.cross.grayson};
      font-weight: 700;
    }
  }
`;

export const StyledFAQSubtitle = styled(Subtitle)`
  margin-top: ${rem('40px')};
  color: ${({ theme }) => theme.colors.cross.black};
`;

export const StyledButtonHolder = styled.div`
  display: flex;
  justify-content: center;
  position: fixed;
  bottom: 0;
  left: 0;
  padding: ${rem('16px')};
  background-color: ${({ theme }) => theme.colors.main};
  width: 100%;

  & a {
    width: 100%;
  }
`;
